import { ChangeDetectionStrategy, Component, Input, Output, OnDestroy, OnInit, EventEmitter } from '@angular/core';
import { enumCompanyPaymentType } from '@app/data-layer/enums/companies';
import { enumOrganizationRole } from '@app/data-layer/enums/organizations';
import { enumPaymentProvider } from '@app/data-layer/enums/payments';
import { SubscriptionModel } from '@app/data-layer/models/common';
import { OrganizationMemberModel, OrganizationModel } from '@app/data-layer/models/organizations';
import { BillModel, PaymentMethodModel } from '@app/data-layer/models/payments';
import { UserModel } from '@app/data-layer/models/user';
import { CompaniesService } from '@services/companies.service';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'organization-payment-and-billing-card',
  templateUrl: './organization-payment-and-billing-card.component.html',
  styleUrls: ['./organization-payment-and-billing-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationPaymentAndBillingCardComponent implements OnInit, OnDestroy {
  @Input() public organization: OrganizationModel;
  @Input() public organizationMembers: OrganizationMemberModel[];
  @Input() public organizationSubscriptions: SubscriptionModel[];
  @Input() public isLoadingPaymentMethods: boolean;
  @Input() public isPayPalPaymentTokenLoading: boolean = false;
  @Input() public selectedSubscription: SubscriptionModel;
  @Input() public allPaymentMethods: PaymentMethodModel[] = [];
  @Input() public paymentMethods: PaymentMethodModel[] = [];
  @Input() public monthlyBillList: BillModel[] = [];
  @Output() public resetSelectedSubscription: EventEmitter<void> = new EventEmitter<void>();
  @Output() public deletePayment: EventEmitter<enumPaymentProvider> = new EventEmitter<enumPaymentProvider>();
  @Output() public paypalPaymentToken: EventEmitter<void> = new EventEmitter<void>();
  @Output() public updatePaymentType: EventEmitter<enumCompanyPaymentType> = new EventEmitter<enumCompanyPaymentType>();
  @Output() public stripePaymentToken: EventEmitter<void> = new EventEmitter<void>();
  @Output() public payMonthlyBill: EventEmitter<number> = new EventEmitter<number>();
  @Output() public updateSubscription: EventEmitter<number> = new EventEmitter<number>();
  @Output() public removeSubscription: EventEmitter<void> = new EventEmitter<void>();

  public isLoadingPaymentForm: boolean;
  // public companiesWithPaymentMethod: CompanyModel[];
  public currentUser: UserModel;
  public currentUserMember: OrganizationMemberModel;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private companiesService: CompaniesService) {}

  ngOnInit(): void {
    //  Commented following task: #11011
    // this.companiesWithPaymentMethod = this.organization.companies
    //   .filter((company) => !!company.defaultPaymentMethodId)
    //   .filter((company, index, self) => {
    //     return index === self.findIndex((c) => c.defaultPaymentMethodDescription === company.defaultPaymentMethodDescription);
    //   });

    this.currentUser = this.companiesService.getUser();
    this.currentUserMember = this.organizationMembers?.find((member) => member.user.userId === this.currentUser.uid);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  public get isOrganizationAdmin(): boolean {
    return this.currentUserMember?.role === enumOrganizationRole.ADMIN;
  }

  // Commented following task: #11011
  // public getCompanyPaymentMethodIcon(company: CompanyModel): string {
  //   return (this.allPaymentMethods || []).find((item: PaymentMethodModel) => item.id === company.defaultPaymentMethodId)?.icon;
  // }

  // Commented following task: #11011
  // public getPaymentMethodCompanyNames(defaultPaymentMethodId: number, defaultPaymentMethodDescription: string): string {
  //   const samePaymentMethodCompanies = this.organization.companies?.filter(
  //     (c) => c?.defaultPaymentMethodId === defaultPaymentMethodId && c?.defaultPaymentMethodDescription === defaultPaymentMethodDescription,
  //   );
  //   const samePaymentMethodCompanyNamesSliced = samePaymentMethodCompanies
  //     .slice(0, 3)
  //     .map((c) => UtilsHelper.limitLength(c.businessName, 15));
  //   const lastSamePaymentMethodCompanyNamesSliced = samePaymentMethodCompanyNamesSliced[samePaymentMethodCompanyNamesSliced.length - 1];
  //   return (
  //     samePaymentMethodCompanyNamesSliced.join(', ') +
  //     (samePaymentMethodCompanies.length > 3 && !this.isWith3Dots(lastSamePaymentMethodCompanyNamesSliced) ? '...' : '')
  //   );
  // }

  private isWith3Dots(value: string): boolean {
    return value.slice(-3) === '...';
  }
}
